import { createApp } from 'vue';
import App from './App.vue';
import router from './base/router';
import store from './base/store';
import VCalendar from 'v-calendar';
import VueCookies from 'vue3-cookies';
import {initOptimizelyClient} from "./base/FeatureFlags";

import {Mask} from "./base/directives/Mask";
import {ClickOutside} from "./base/directives/ClickOutside";

createApp(App)
    .use(store)
    .use(router)
    .use(VCalendar)
    .use(VueCookies)
    .directive('mask', Mask)
    .directive('click-outside', ClickOutside)
    .mount('#app');

import './base/assets/css/bootstrap.min.css';
import './base/assets/css/bootstrap-reset.css';
import './base/assets/css/font-awesome.min.css';
import './base/assets/css/style.css';
import 'dropzone/dist/dropzone.css';

initOptimizelyClient();
